/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/native-symbol');

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/utcom-ui-kit/~/core-js/internals/use-symbol-as-uid.js
// module id = 1614
// module chunks = 118